import React from 'react'
import {Route, Redirect} from 'react-router-dom'

const AuthenticatedRoute = ({component: C, authentication, ...rest}) => {
    const {loggedIn} = authentication

    return (
        // Extract Component and props, then pass route parameters list path, exact in ..rest
        <Route
            {...rest}
            render={() => (loggedIn ? <C /> : <Redirect to={'/login'} />)}
        />
    )
}

export default AuthenticatedRoute
